<template>
  <ReportBaseSelectFilter
    class="action-filter"
    label="Actions"
    placeholder="All actions"
    :options="options"
    query-property="actions"
  />
</template>

<script>
export default {
  name: 'ReportActionFilter',
  computed: {
    options() {
      return [
        { id: '1', text: 'Add' },
        { id: '2', text: 'Edit' },
        { id: '3', text: 'Delete' },
        { id: '4', text: 'Move' },
        { id: '5', text: 'Override Add' },
        { id: '6', text: 'Override Edit' },
        { id: '7', text: 'Override Delete' },
        { id: '8', text: 'Override Move' },
      ];
    },
  },
};
</script>
